<div class="protected-appliance-summary">
  <p class="protected-appliance-summary__title">
    {{ "ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_TITLE" | translate }}
  </p>

  <app-description-list class="protected-appliance-summary__list">
    <app-description-list-item
      [data]="appliance()?.applianceName"
      [title]="
        'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_APPLIANCE_TYPE_LABEL'
          | translate
      "
      class="protected-appliance-summary__list-item"
    />
    <app-description-list-item
      [data]="planNumber()"
      [title]="
        'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_NUMBER_LABEL'
          | translate
      "
      class="protected-appliance-summary__list-item"
    />
    <app-description-list-item
      [data]="planStartDate()"
      [title]="
        'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_POLICY_START_DATE_LABEL'
          | translate
      "
      class="protected-appliance-summary__list-item"
    />

    @if (hasDiscountedMonths()) {
      <app-description-list-item
        [data]="'FREE'"
        [title]="
          'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_FIRST_X_PAYMENTS_LABEL'
            | translate
              : { numberOfDiscountedMonths: numberOfDiscountedMonths() }
        "
        class="protected-appliance-summary__list-item"
      />
      <app-description-list-item
        [data]="quoteMonthlyPayment().subsequentPayment | currencyFormat"
        [title]="
          'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_SUBSEQUENT_PAYMENT_LABEL'
            | translate
        "
        class="protected-appliance-summary__list-item"
      />
    } @else {
      <app-description-list-item
        [data]="quoteMonthlyPayment().subsequentPayment | currencyFormat"
        [title]="
          'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_SUBSEQUENT_PAYMENT_LABEL'
            | translate
        "
        class="protected-appliance-summary__list-item"
      />
    }
    <app-description-list-item
      [data]="appliancePurchaseDate()"
      [title]="
        'ORDER_CONFIRMATION_PROTECTED_APPLIANCE_SUMMARY_PURCHASE_DATE_LABEL'
          | translate
      "
      class="protected-appliance-summary__list-item"
    />
  </app-description-list>
</div>
